import { defineService } from 'derivita/ts/service_locator/container';

export interface ProductAnalytics {
  captureEvent(name: string, properties: Record<string, unknown>): void;
  captureLog(msg: string, level?: string): void;
}

export const ProductAnalytics =
  defineService<ProductAnalytics>('ProductAnalytics');
